const NotificationScreenEnum = {
    HOME: "Home",
    MENU: "Menu",
    PROFILE: "Profile",
    CREDIT: "Credit",
    ORDERS: "Orders",
    FOTOMATS: "Fotomats"
}

export default NotificationScreenEnum;